import { useEffect, useRef } from "react";

// Refetches when a chat's activity moves on, not when a chat first loads: the
// query's own load covers that.
export const useRefetchOnActivity = (
  chatId: string | undefined,
  activity: string | undefined,
  refetch: () => unknown,
) => {
  const last = useRef({ chatId, activity });
  useEffect(() => {
    const previous = last.current;
    last.current = { chatId, activity };
    if (!previous.activity || !activity) return;
    if (previous.chatId === chatId && previous.activity !== activity) {
      void refetch();
    }
  }, [chatId, activity, refetch]);
};
